<template>
  <ErrorPage
    status-code="500"
    status-message="WE EXPERIENCED AN ERROR"
  />
</template>

<script lang="ts" setup>
import ErrorPage from './components/error_page.vue';
</script>
